// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.proposal-card-add .ant-card-body {
  margin-top: 0.625rem !important;
}
.proposal-card {
  display: flex;
  width: 8rem;
  min-height: 8rem;
  box-shadow: none !important;
  border: 0.063rem solid #c9d3cc;
  cursor: pointer;
  padding: 0.5rem !important;
  align-items: center;
  justify-content: center;
}
.proposal-card .ant-card-body {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.5rem !important;
}
.proposal-card .proposal-card-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  width: 100%;
}
.proposal-card .proposal-card-main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.proposal-card .proposal-card-main img {
  max-width: 90%;
  width: 100%;
  object-fit: contain;
}
.proposal-card .proposal-card-main .proposal-number {
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  color: #1a1a1a;
  line-height: 1.2;
}
.proposal-card .proposal-subtitle {
  font-size: 0.625rem;
  font-weight: 500;
  text-align: center;
  color: #6b7280;
  line-height: 1.2;
  border-top: 0.063rem solid #e5e7eb;
  padding-top: 0.375rem;
  width: 100%;
}
@media (max-width: 452px) {
  .proposal-card {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/gyramais/ProposalCard/styles.less"],"names":[],"mappings":"AAAA;EACE,+BAAA;AACF;AAEA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AATA;EAYI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,0BAAA;AAAJ;AAhBA;EAoBI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AADJ;AAxBA;EA6BI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;AAFJ;AA9BA;EAmCM,cAAA;EACA,WAAA;EACA,mBAAA;AAFN;AAnCA;EAyCM,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAHN;AA1CA;EAkDI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;EACA,qBAAA;EACA,WAAA;AALJ;AAQE;EAAA;IACE,WAAA;EALF;AACF","sourcesContent":[".proposal-card-add .ant-card-body {\n  margin-top: 0.625rem !important;\n}\n\n.proposal-card {\n  display: flex;\n  width: 8rem;\n  min-height: 8rem;\n  box-shadow: none !important;\n  border: 0.063rem solid #c9d3cc;\n  cursor: pointer;\n  padding: 0.5rem !important;\n  align-items: center;\n  justify-content: center;\n\n  .ant-card-body {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    padding: 0.5rem !important;\n  }\n\n  .proposal-card-inner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.375rem;\n    width: 100%;\n  }\n\n  .proposal-card-main {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n\n    img {\n      max-width: 90%;\n      width: 100%;\n      object-fit: contain;\n    }\n\n    .proposal-number {\n      font-size: 0.75rem;\n      font-weight: 600;\n      text-align: center;\n      color: #1a1a1a;\n      line-height: 1.2;\n    }\n  }\n\n  .proposal-subtitle {\n    font-size: 0.625rem;\n    font-weight: 500;\n    text-align: center;\n    color: #6b7280;\n    line-height: 1.2;\n    border-top: 0.063rem solid #e5e7eb;\n    padding-top: 0.375rem;\n    width: 100%;\n  }\n\n  @media (max-width: 452px) {\n    width: 100%;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
